export default __webpack_public_path__ + "static/media/logo-dok-darkgrey.de4645a9.png";